
export interface EmergencyLocation {
  id: string;
  name: string;
  type: 'hospital' | 'fire' | 'police';
  address: string;
  phone: string;
  hours: string;
  lat: number;
  lng: number;
}

export const emergencyLocations: EmergencyLocation[] = [
  {
    id: 'sutter-roseville',
    name: 'Sutter Roseville Medical Center',
    type: 'hospital',
    address: '1 Medical Plaza Dr, Roseville, CA 95661',
    phone: '(916) 781-1000',
    hours: 'ER Open 24/7',
    lat: 38.7396,
    lng: -121.2649,
  },
  {
    id: 'kaiser-roseville',
    name: 'Kaiser Permanente Roseville',
    type: 'hospital',
    address: '1600 Eureka Rd, Roseville, CA 95661',
    phone: '(916) 784-4000',
    hours: 'ER Open 24/7',
    lat: 38.7521,
    lng: -121.2530,
  },
  {
    id: 'adventist-roseville',
    name: 'Adventist Health Roseville',
    type: 'hospital',
    address: '401 Sunrise Ave, Roseville, CA 95661',
    phone: '(916) 781-4000',
    hours: 'ER Open 24/7',
    lat: 38.7462,
    lng: -121.2458,
  },
  {
    id: 'roseville-pd',
    name: 'Roseville Police Department',
    type: 'police',
    address: '1051 Junction Blvd, Roseville, CA 95678',
    phone: '(916) 774-5000',
    hours: '24/7 Dispatch',
    lat: 38.7527,
    lng: -121.2897,
  },
  {
    id: 'placer-sheriff',
    name: 'Placer County Sheriff — South Placer',
    type: 'police',
    address: '6140 Horseshoe Bar Rd, Loomis, CA 95650',
    phone: '(530) 886-5375',
    hours: '24/7 Dispatch',
    lat: 38.7943,
    lng: -121.1870,
  },
  {
    id: 'chp-gold-run',
    name: 'CHP — Gold Run Division',
    type: 'police',
    address: '355 Nevada St, Auburn, CA 95603',
    phone: '(530) 889-0461',
    hours: '24/7',
    lat: 38.8966,
    lng: -121.0769,
  },
  {
    id: 'fire-station-1',
    name: 'Roseville Fire Station 1',
    type: 'fire',
    address: '401 Oak St, Roseville, CA 95678',
    phone: '(916) 774-5800',
    hours: '24/7',
    lat: 38.7523,
    lng: -121.2889,
  },
  {
    id: 'fire-station-2',
    name: 'Roseville Fire Station 2',
    type: 'fire',
    address: '1500 Cirby Way, Roseville, CA 95661',
    phone: '(916) 774-5800',
    hours: '24/7',
    lat: 38.7440,
    lng: -121.2680,
  },
  {
    id: 'fire-station-3',
    name: 'Roseville Fire Station 3',
    type: 'fire',
    address: '1700 Foothills Blvd, Roseville, CA 95747',
    phone: '(916) 774-5800',
    hours: '24/7',
    lat: 38.7700,
    lng: -121.3200,
  },
  {
    id: 'fire-station-4',
    name: 'Roseville Fire Station 4',
    type: 'fire',
    address: '2001 Woodcreek Oaks Blvd, Roseville, CA 95747',
    phone: '(916) 774-5800',
    hours: '24/7',
    lat: 38.7750,
    lng: -121.3450,
  },
  {
    id: 'fire-station-5',
    name: 'Roseville Fire Station 5',
    type: 'fire',
    address: '8890 Foothills Blvd, Roseville, CA 95747',
    phone: '(916) 774-5800',
    hours: '24/7',
    lat: 38.7900,
    lng: -121.3350,
  },
  {
    id: 'fire-station-7',
    name: 'Roseville Fire Station 7',
    type: 'fire',
    address: '7500 Westfield Loop, Roseville, CA 95747',
    phone: '(916) 774-5800',
    hours: '24/7',
    lat: 38.7820,
    lng: -121.3580,
  },
];

export const locationTypeConfig = {
  hospital: {
    label: 'Hospitals & Medical',
    icon: 'ri-hospital-line',
    color: 'text-red-600',
    bg: 'bg-red-50',
    border: 'border-red-200',
    dot: 'bg-red-500',
    badge: 'bg-red-100 text-red-700',
  },
  fire: {
    label: 'Fire Stations',
    icon: 'ri-fire-line',
    color: 'text-orange-600',
    bg: 'bg-orange-50',
    border: 'border-orange-200',
    dot: 'bg-orange-500',
    badge: 'bg-orange-100 text-orange-700',
  },
  police: {
    label: 'Police & Law Enforcement',
    icon: 'ri-shield-star-line',
    color: 'text-teal-600',
    bg: 'bg-teal-50',
    border: 'border-teal-200',
    dot: 'bg-teal-500',
    badge: 'bg-teal-100 text-teal-700',
  },
};
